import { Component, OnInit, OnDestroy, EventEmitter, Output } from '@angular/core';
import { ModalService } from '@app/services/modal.service';

@Component({
  selector: 'app-modal-delete-upload',
  templateUrl: './modal-delete-upload.component.html',
  styleUrls: ['./modal-delete-upload.component.scss']
})
export class ModalDeleteUploadComponent implements OnInit {
  @Output() confirmDelete = new EventEmitter<void>();

  constructor(public modal: ModalService) { }

  ngOnInit() {
  }
  onDelete() {
    this.confirmDelete.emit();   
    this.modal.close();
  }
  closeModal() {
    this.modal.close();
  }

}
